export const LOAD_APP_CONTEXT = 'LOAD_APP_CONTEXT';

export const loadAppContext = () => ({
  type: LOAD_APP_CONTEXT
});
